import $ from 'jquery';

Drupal.behaviors.languageSwitcherToggle = {
  attach: function (context, settings) {
    once('languageSwitcher', '.language-switcher__current', context).forEach((languageSwitcher) => {
      $(languageSwitcher).on('click', function (e) {
        e.preventDefault();
        $('html').removeClass('my-pages-dropdown-is-active').toggleClass('lang-switcher-is-active');
      });
    });
  }
};
